import Vue from 'vue';
import Vuex from 'vuex';
import Auth from '../api/modules/auth';
import { setApiToken } from '../api/modules/core';
import queries from './modules/queries';
import issues from './modules/issues';
import sims from './modules/sims';
import flights from './modules/flights';
import agents from './modules/agents';
import applications from './modules/applications';
import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

Vue.use(Vuex);

const types = {
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  AUTH_FAIL: 'AUTH_FAIL',
  SET_IDENTITIES: 'SET_IDENTITIES',
  SET_SNACKBAR: 'SET_SNACKBAR',
}

const debug = process.env.NODE_ENV !== 'production';

const state = {
  user: null,
  identities: null,
  snackbar: {
    text: null,
    active: false,
  }
}

const getters = {
  auth: state => state.user != null,
  canBatch: state => {
    if (state.user) {
      return state.user.vendor.can_batch;
    }

    return false;
  },

  allowPhoneCount: state => {
    if (state.user) {
      return state.user.vendor.allow_phone_count;
    }

    return 1;
  },

  isManager: state => {
    if (state.user) {
      return state.user.is_manager
    }

    return false;
  },

  isAbroad: state => {
    const category = _.get(state.user, 'vendor.category');
    if (!category) {
      return false;
    }

    return category.indexOf('境外') > -1;
  },
}

const actions = {
  me({ commit, dispatch }) {
    return Auth.me().then(response => {
      commit(types.AUTH_SUCCESS, response.data.result);
      dispatch('identities');
      return true;
    }).catch(error => {
      commit(types.AUTH_FAIL);
      commit(types.SET_IDENTITIES, null);
      return false;
    });
  },

  identities({ commit }) {
    return Auth.identities().then(response => {
      commit(types.SET_IDENTITIES, response.data.result);
    }).catch(error => {
      commit(types.SET_IDENTITIES, null);
    });
  },

  loginByToken({ dispatch }, token) {
    setApiToken(token);
    return dispatch('me');
  },

  logout({ commit }) {
    setApiToken(null);
    commit('queries/GET_QUERIES_ERROR');
    commit('issues/GET_ISSUES_ERROR');
    commit(types.AUTH_FAIL);
  },

  setSnackbar({ commit }, snackbar) {
    commit(types.SET_SNACKBAR, snackbar);
  },
}

const mutations = {
  [types.AUTH_SUCCESS](state, user) {
    state.user = user;
  },

  [types.AUTH_FAIL](state) {
    state.user = null;
  },

  [types.SET_IDENTITIES](state, identities) {
    state.identities = identities;
  },

  [types.SET_SNACKBAR](state, options) {
    state.snackbar = {
      ...{
        active: true,
        timeout: 3000,
      },
      ...options,
    }
  },
}

export default new Vuex.Store({
  modules: {
    queries,
    issues,
    sims,
    flights,
    agents,
    applications,
  },
  plugins: process.env.MIX_LOGROCKET_ENABLED == 'true' ? [createPlugin(LogRocket)] : [],
  strict: debug,
  state,
  getters,
  actions,
  mutations,
})
